module.exports = __webpack_public_path__ + "img/esa-logo.59bee709.png";